export default "__VITE_ASSET__ZRzukIdG__"